import React, { useEffect } from 'react'
import { useState } from "react";

import { makeStyles } from '@material-ui/core/styles';

import LoadingComponent from '../../../components/Loading';

import { useSelector } from "react-redux";

import {
    selectUsuarioSeleccionado,
} from "../../../redux/reducer/loginReducer";
// import { deleteInquilino, getAlumnos, inquilinoDelete } from '../../../../services/Alumnos';
import { Box, Button, Grid, IconButton, MenuItem, Select, FormControl, InputLabel, TextField, Typography } from '@material-ui/core';
import { DataGrid, GridToolbarDensitySelector, GridToolbarFilterButton} from '@mui/x-data-grid';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import { seguimientoTutoreslList } from '../../../services/tutores';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

// import Moment from 'react-moment';

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '80px'
    },
}));

export default function SeguimientoTutoresContent() {
    const classes = useStyles();

    const [tutores, setTutores] = useState([]);
    const [evolucionMensual, setEvolucionMensual] = useState([]);
    const [tutorSeleccionado, setTutorSeleccionado] = useState('');
    const [loading, setLoading] = useState(false)
    const [loadingMensaje, setLoadingMensaje] = useState("")

    const hoy = new Date();
    const mesActual = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
    const mes2Atras = (() => { const d = new Date(hoy.getFullYear(), hoy.getMonth() - 2, 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; })();
    const [mesInicio, setMesInicio] = useState(mes2Atras);
    const [mesFin, setMesFin] = useState(mesActual);

    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });
    // const history = useHistory()


    /* -------------------------------------------------------------------------- */
    /*                                  UseEffect                                 */
    /* -------------------------------------------------------------------------- */
    const mesAFechaInicio = (mes) => `${mes}-01`;
    const mesAFechaFin = (mes) => {
        const [anio, m] = mes.split('-').map(Number);
        const ultimoDia = new Date(anio, m, 0).getDate();
        return `${mes}-${ultimoDia}`;
    };

    const cargarDatos = (inicio, fin) => {
        setLoading(true)
        setLoadingMensaje("Cargando tutores")

        const usuario_id = usuarioSeleccionado.id

        seguimientoTutoreslList({ usuario_id, fecha_inicio: mesAFechaInicio(inicio), fecha_fin: mesAFechaFin(fin) }).then((response) => {
            if (response) {
                setTutores(response.tutores)
                setEvolucionMensual(response.evolucion_mensual || [])
                setTutorSeleccionado('')
            }
            setLoading(false)
        });
    }

    useEffect(() => {
        cargarDatos(mesInicio, mesFin)
    }, [])

    /* -------------------------------------------------------------------------- */
    /*                           Definicion de columnas                           */
    /* -------------------------------------------------------------------------- */

    const columnas = 
    [
      { field: 'id', hide: false, headerName: 'ID' },
      { field: 'tutor', hide: false, headerName: 'Tutor', width: 250 },
      { field: 'num_entregas', headerName: 'Entregas', minWidth: 150, flex: 1 },
      { field: 'num_simulacros', headerName: 'Simulacros', minWidth: 150, flex: 1 },
      { field: 'num_dudas', headerName: 'Dudas', minWidth: 150, flex: 1 },
      // { field: 'num_tutorias', headerName: 'Tutorias', minWidth: 150, flex: 1 },
      { field: 'num_alumnos', headerName: 'Alumnos', minWidth: 150, flex: 1 },
      { field: 'min_conectado', headerName: 'Min Conectado', minWidth: 150, flex: 1, valueFormatter: ({ value }) => value != null ? Math.round(value) : '' },
    //   // {
    //   //   field: 'actions',
    //   //   type: 'actions',
    //   //   width: 80,
    //   //   getActions: (params) => [
    //   //     <GridActionsCellItem
    //   //       icon={<EditIcon />}
    //   //       label="Modificar"
    //   //       component={Link}
    //   //       to={`alumnos/detalle/${params.id}`}
    //   //       showInMenu
    //   //     />,
    //   //   ],
    //   // }
    ]

    /* -------------------------------------------------------------------------- */
    /*                                  Contenido                                 */
    /* -------------------------------------------------------------------------- */
    function QuickSearchToolbar(props) {
        const classes = useStyles();
      
        return (
          <div className={classes.rootFilter}>
            <div>
              <GridToolbarFilterButton />
              <GridToolbarDensitySelector />
            </div>
            <TextField
              variant="standard"
              value={props.value}
              onChange={props.onChange}
              placeholder="Buscar…"
              className={classes.textFieldFilter}
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
                endAdornment: (
                  <IconButton
                    title="Clear"
                    aria-label="Clear"
                    size="small"
                    style={{ visibility: props.value ? 'visible' : 'hidden' }}
                    onClick={props.clearSearch}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </div>
        );
      }
      
      QuickSearchToolbar.propTypes = {
        clearSearch: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired,
      };

    const Contenido = () => {
        const [rows, setRows] = React.useState(tutores);
        const [searchText, setSearchText] = React.useState('');
        const requestSearch = (searchValue) => {
          // console.log(searchValue)
          setSearchText(searchValue);
          const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
          // const searchRegex = new RegExp(`.*${searchValue}.*`, 'ig');
          const filteredRows = tutores.filter((row) => {
              return Object.keys(row).some((field) => {
                  // console.log(field)
                  // console.log(row)
                  return searchRegex.test(row[field]);
              });
          });
          setRows(filteredRows);
        };

        // const handleAlumnoDetalle = (row) => {
        //   console.log(row)
        //   history.push('alumnos/detalle/' + row.alumno_id )
        // }
        // const [anchorElOpciones, setAnchorElOpciones] = React.useState(null);
        // const open = Boolean(anchorElOpciones);
      
        // const handleClickOpciones = (event) => {
        //   setAnchorElOpciones(event.currentTarget);
        // };
      
        // const handleCloseOpciones = () => {
        //   setAnchorElOpciones(null);
        // };

        // const handleExportarTelefonos = () => {
        //   setAnchorElOpciones(null);
        // }
        return (
          <>

            <Box mt={12} mb={3} mx={2}>
              <Typography variant="h5" component="h3" gutterBottom display='inline' style={{fontWeight: 500}} >
                  Seguimiento de tutores
              </Typography>
            </Box>

            <Box mx={2} mb={2}>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <TextField
                    label="Mes inicio"
                    type="month"
                    value={mesInicio}
                    onChange={(e) => setMesInicio(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item>
                  <TextField
                    label="Mes fin"
                    type="month"
                    value={mesFin}
                    onChange={(e) => setMesFin(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => cargarDatos(mesInicio, mesFin)}
                  >
                    Buscar
                  </Button>
                </Grid>
              </Grid>
            </Box>

            <div style={{ height: 700, width: '100%', padding:"0 15px" }}>
                <DataGrid
                    rows={rows}
                    columns={columnas}
                    rowHeight={30}
                    components={{ Toolbar: QuickSearchToolbar }}
                    // onRowDoubleClick={ (evento ) => handleAlumnoDetalle(evento.row) }
                    componentsProps={{
                        toolbar: {
                          value: searchText,
                          onChange: (event) => requestSearch(event.target.value),
                          clearSearch: () => requestSearch(''),
                        },
                    }}
                />
            </div>

            <Box mx={2} mt={4} mb={2}>
                <Typography variant="h6" gutterBottom style={{ fontWeight: 500 }}>
                    Evolución temporal por tutor
                </Typography>
                <FormControl variant="outlined" size="small" style={{ minWidth: 300 }}>
                    <InputLabel>Seleccionar tutor</InputLabel>
                    <Select
                        value={tutorSeleccionado}
                        onChange={(e) => setTutorSeleccionado(e.target.value)}
                        label="Seleccionar tutor"
                    >
                        <MenuItem value=""><em>-- Seleccionar --</em></MenuItem>
                        {tutores
                            .filter((t) => evolucionMensual.some((e) => String(e.id) === String(t.id)))
                            .map((t) => (
                                <MenuItem key={t.id} value={t.id}>{t.tutor}</MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Box>

            {tutorSeleccionado && (() => {
                const datosGrafica = evolucionMensual
                    .filter((e) => String(e.id) === String(tutorSeleccionado))
                    .map((e) => ({
                        periodo: e.periodo,
                        Entregas: parseInt(e.num_entregas, 10),
                        Simulacros: parseInt(e.num_simulacros, 10),
                        Dudas: parseInt(e.num_dudas, 10),
                        Alumnos: parseInt(e.num_alumnos, 10),
                    }));
                const graficas = [
                    { key: 'Entregas', color: '#1976d2' },
                    { key: 'Simulacros', color: '#388e3c' },
                    { key: 'Dudas', color: '#f57c00' },
                    { key: 'Alumnos', color: '#7b1fa2' },
                ];
                return (
                    <Box mx={2} mb={4}>
                        <Grid container spacing={2}>
                            {graficas.map(({ key, color }) => (
                                <Grid item xs={12} sm={6} key={key}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 500, marginBottom: 4 }}>
                                        {key}
                                    </Typography>
                                    <ResponsiveContainer width="100%" height={220}>
                                        <BarChart data={datosGrafica} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="periodo" />
                                            <YAxis />
                                            <Tooltip />
                                            <Bar dataKey={key} fill={color} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                );
            })()}

                </>

                // :
                // <EmptyComponent mensaje="No hay datos para mostrar" />
        )
    }
    
    /* -------------------------------------------------------------------------- */
    /*                                   Return                                   */
    /* -------------------------------------------------------------------------- */
    return (
        <div className={classes.container}>
            {
                (loading ?
                    
                    <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
                    
                    :
                    
                    <Contenido />
                )
            }
        </div>
    )
}
